import { boolean, string, ref, object } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { nameRegex, password } from '../../../utils/validation.js';
import { T as TERMS_MESSAGE, i as FIRST_NAME_MESSAGE, I as INCORRECT_NAME_MESSAGE, L as LAST_NAME_MESSAGE, a as INCORRECT_EMAIL_MESSAGE, E as EMAIL_REQUIRED_MESSAGE, f as MIN_CHARACTERS_MESSAGE, g as MAX_CHARACTERS_MESSAGE, M as MATCH_PASSWORDS_MESSAGE, d as CONFIRM_PASSWORD_REQUIRED_MESSAGE, h as CAPTCHA_REQUIRED_MESSAGE } from '../../../validation-g1IuPS7K.js';
import { RegisterFormType } from '../../../types/index.js';
import '../../../checkout-Ee1eEXQH.js';
import '../../../menu-0TyOg98i.js';
import '../../../product-_pRduMz7.js';
import '../../../modal-6vnX5SO3.js';

const initialValues = {
    email: '',
    confirmPassword: '',
    password: '',
    captcha: '',
    createAccountAgreeTerms: false,
    createAccountAgreeSubscribe: false,
    accorSubscribe: false,
    brandSubscribe: false,
};

/* eslint-disable @typescript-eslint/default-param-last */
const getValidationSchema = (captcha = false, formType) => {
    const validationSchema = {
        createAccountAgreeTerms: boolean().oneOf([true], TERMS_MESSAGE).required(TERMS_MESSAGE),
        createAccountAgreeSubscribe: boolean(),
        brandSubscribe: boolean(),
        firstname: formType === RegisterFormType.Page
            ? string().required(FIRST_NAME_MESSAGE).matches(nameRegex, INCORRECT_NAME_MESSAGE)
            : null,
        lastname: formType === RegisterFormType.Page
            ? string().required(LAST_NAME_MESSAGE).matches(nameRegex, INCORRECT_NAME_MESSAGE)
            : null,
        email: string().email(INCORRECT_EMAIL_MESSAGE).required(EMAIL_REQUIRED_MESSAGE),
        password,
        confirmPassword: string()
            .trim()
            .min(8, MIN_CHARACTERS_MESSAGE)
            .max(100, MAX_CHARACTERS_MESSAGE)
            .oneOf([ref('password')], MATCH_PASSWORDS_MESSAGE)
            .required(CONFIRM_PASSWORD_REQUIRED_MESSAGE),
        ...(captcha && {
            captcha: string().required(CAPTCHA_REQUIRED_MESSAGE),
        }),
    };
    return yupResolver(object().shape(validationSchema));
};

export { getValidationSchema, initialValues };
//# sourceMappingURL=index.js.map
